<div class="product-option-selector-content">
	<form
		[formGroup]="productOptionsForm"
		*ngIf="keys(productVariables).length"
		[gFormAsterisk]="productOptionsForm"
		[gFormAsteriskRequired]="requiredFields"
	>
		<fieldset [disabled]="readOnly">
			<div *ngFor="let variable of productVariables" class="option-item">
				<div *ngIf="!variable.hidden" [ngClass]="{ 'validation-padding': addPaddingToOptionItem }">
					<label *ngIf="showHeader" [for]="variable.key" class="header">{{ variable.label }}</label>
					<div *ngIf="variable.type === 'select'">
						<g-select
							class="dark"
							[ngClass]="getInputIdentifierClass(variable)"
							[items]="variable.keyValuePairs"
							[formControlName]="variable.key"
							[optionLabelFormatter]="getDropdownOptionText(variable)"
							[selectedLabelFormatter]="getDropdownButtonText(variable)"
							bindLabel="value"
							bindKey="key"
						/>
					</div>

					<div *ngIf="variable.type === 'number'">
						<div class="form-group">
							<g-numeric-input
								[ngClass]="getInputIdentifierClass(variable)"
								[formControlName]="variable.key"
								[placeholder]="variable.placeholder"
								[defaultValue]="variable.minValue"
								[readonly]="readOnly"
								[min]="variable.minValue"
								[max]="variable.maxValue"
								[unit]="variable.unit"
								[title]="variable.placeholder"
								(valueChange)="patchSelectedValueToForm(variable, $event)"
							/>
						</div>
					</div>

					<div *ngIf="variable.type === 'text'">
						<div class="form-group">
							<input
								type="text"
								trim="blur"
								class="form-control"
								[ngClass]="getInputIdentifierClass(variable)"
								[formControlName]="variable.key"
								[attr.id]="variable.key"
								[attr.placeholder]="variable.placeholder"
							/>
						</div>
					</div>

					<div class="validation-error">
						{{ formErrors$ | async | validationField: variable.key }}
					</div>
				</div>
			</div>
		</fieldset>
	</form>
</div>
